import React, { useState } from 'react';
import DashboardStats from '../components/sections/DashboardStats';
import ReferralInfo from '../components/sections/ReferralInfo';
import PendingROI from '../components/sections/PendingROI';
import ActivityFeed from '../components/sections/ActivityFeed';

export default function Dashboard() {
  const [refresh, setRefresh] = useState(0);
  const trigger = () => setRefresh((v) => v + 1);

  return (
    <div className="fade-in">
      <div className="page-header">
        <div>
          <h2 className="page-title"><span className="title-accent">◆</span> Dashboard</h2>
          <div className="page-subtitle">Overview of your portfolio & earnings</div>
        </div>
      </div>

      <DashboardStats refreshFlag={refresh} />

      <div className="grid grid-2 mt-4">
        <PendingROI onSuccess={trigger} />
        <ReferralInfo />
      </div>

      <div className="mt-4">
        <ActivityFeed />
      </div>
    </div>
  );
}
